export interface Category {
  name: string;
  url: string;
  seq: string;
  imageQuery: string;
}

export const categories: Category[] = [
  {
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    seq: "cat-shoes",
    imageQuery: "Elegant%20designer%20sneakers%20on%20a%20soft%20cream%20background%2C%20minimalist%20product%20photography%20with%20gentle%20natural%20lighting%2C%20clean%20composition%20with%20subtle%20shadows%2C%20warm%20neutral%20tones%2C%20editorial%20style%20with%20soft%20focus%20edges",
  },
  {
    name: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    seq: "cat-hoodies",
    imageQuery: "Cozy%20oversized%20hoodie%20in%20warm%20beige%20tone%20on%20a%20soft%20cream%20background%2C%20minimalist%20product%20photography%20with%20gentle%20natural%20lighting%2C%20clean%20composition%2C%20neutral%20warm%20aesthetic%2C%20editorial%20style",
  },
  {
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    seq: "cat-tshirts",
    imageQuery: "Premium%20cotton%20white%20t-shirt%20folded%20neatly%20on%20a%20soft%20cream%20background%2C%20minimalist%20product%20photography%20with%20gentle%20natural%20lighting%2C%20clean%20and%20simple%20composition%2C%20warm%20neutral%20tones",
  },
  {
    name: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    seq: "cat-jackets",
    imageQuery: "Stylish%20lightweight%20bomber%20jacket%20in%20neutral%20camel%20color%20on%20a%20soft%20cream%20background%2C%20minimalist%20product%20photography%20with%20gentle%20natural%20lighting%2C%20clean%20composition%2C%20editorial%20style",
  },
  {
    name: "Pants/Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    seq: "cat-pants",
    imageQuery: "Well-tailored%20linen%20trousers%20in%20warm%20sand%20color%20on%20a%20soft%20cream%20background%2C%20minimalist%20product%20photography%20with%20gentle%20natural%20lighting%2C%20clean%20composition%2C%20neutral%20warm%20aesthetic",
  },
  {
    name: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    seq: "cat-headwear",
    imageQuery: "Classic%20baseball%20cap%20in%20soft%20beige%20tone%20on%20a%20cream%20background%2C%20minimalist%20product%20photography%20with%20gentle%20natural%20lighting%2C%20clean%20composition%2C%20warm%20neutral%20aesthetic",
  },
  {
    name: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    seq: "cat-sets",
    imageQuery: "Coordinated%20matching%20two-piece%20set%20in%20soft%20neutral%20tones%20on%20a%20cream%20background%2C%20minimalist%20product%20photography%20with%20gentle%20natural%20lighting%2C%20clean%20composition%2C%20editorial%20style",
  },
  {
    name: "Underwear/Underpants",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    seq: "cat-underwear",
    imageQuery: "Soft%20cotton%20underwear%20neatly%20folded%20on%20a%20cream%20background%2C%20minimalist%20product%20photography%20with%20gentle%20natural%20lighting%2C%20clean%20and%20simple%20composition%2C%20warm%20neutral%20tones",
  },
  {
    name: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    seq: "cat-jersey",
    imageQuery: "Professional%20sports%20jersey%20in%20elegant%20design%20on%20a%20soft%20cream%20background%2C%20minimalist%20product%20photography%20with%20gentle%20natural%20lighting%2C%20clean%20composition%2C%20editorial%20style",
  },
  {
    name: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    seq: "cat-accessories",
    imageQuery: "Elegant%20minimalist%20watch%20and%20bracelet%20set%20on%20a%20soft%20cream%20background%2C%20product%20photography%20with%20gentle%20natural%20lighting%2C%20clean%20composition%2C%20warm%20neutral%20tones%2C%20editorial%20style",
  },
  {
    name: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    seq: "cat-bags",
    imageQuery: "Premium%20leather%20tote%20bag%20in%20warm%20camel%20color%20on%20a%20soft%20cream%20background%2C%20minimalist%20product%20photography%20with%20gentle%20natural%20lighting%2C%20clean%20composition",
  },
  {
    name: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    seq: "cat-belts",
    imageQuery: "Fine%20leather%20belt%20elegantly%20curled%20on%20a%20soft%20cream%20background%2C%20minimalist%20product%20photography%20with%20gentle%20natural%20lighting%2C%20clean%20composition%2C%20warm%20neutral%20tones",
  },
  {
    name: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    seq: "cat-perfumes",
    imageQuery: "Elegant%20glass%20perfume%20bottle%20with%20minimalist%20design%20on%20a%20soft%20cream%20background%2C%20product%20photography%20with%20gentle%20natural%20lighting%2C%20clean%20composition%2C%20warm%20neutral%20tones",
  },
  {
    name: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    seq: "cat-other",
    imageQuery: "Assorted%20lifestyle%20accessories%20artfully%20arranged%20on%20a%20soft%20cream%20background%2C%20minimalist%20product%20photography%20with%20gentle%20natural%20lighting%2C%20clean%20composition%2C%20warm%20neutral%20tones",
  },
];